/**
 * Browse discovery offer row — same DirectoryEntityRow chrome as ShopDirectoryRowView /
 * GuestFavorites (inline Seznam, comfortable density, trailing slot).
 */
import type { ReactNode } from 'react';
import {
  DirectoryEntityRow,
  type DirectoryEntityRowDensity,
  type DirectoryEntityRowLayout,
} from '../../shared/ui/DirectoryEntityRow.js';
import type { DirectoryEntityThumbProps } from '../../shared/ui/DirectoryEntityThumb.js';
import { buildDiscoveryOfferSubtitleParts } from './browseOfferPresentation.js';
import type { PublicDiscoveryOfferItemDTO } from '../discovery/publicDiscoveryTypes.js';
import type { FormatDistanceMetersLabels } from '../../shared/ui/directoryListFilter.js';

export type DiscoveryOfferRowViewProps = {
  readonly offer: PublicDiscoveryOfferItemDTO;
  readonly distanceFormatter: FormatDistanceMetersLabels;
  readonly thumb: DirectoryEntityThumbProps;
  readonly trailing?: ReactNode;
  readonly titleTestId?: string;
  readonly subtitleTestId?: string;
  readonly density?: DirectoryEntityRowDensity;
  readonly layout?: DirectoryEntityRowLayout;
  readonly testId?: string;
  /** Stage 5 — omit shop/tenant/distance from row subtitle (shown on group header). */
  readonly grouped?: boolean;
};

export function DiscoveryOfferRowView({
  offer,
  distanceFormatter,
  thumb,
  trailing,
  titleTestId,
  subtitleTestId,
  density = 'comfortable',
  layout = 'inline',
  testId,
  grouped = false,
}: DiscoveryOfferRowViewProps): JSX.Element {
  const subtitleText = buildDiscoveryOfferSubtitleParts(offer, distanceFormatter, {
    grouped,
  }).join(' · ');
  const subtitle =
    subtitleTestId !== undefined && subtitleText.length > 0 ? (
      <span data-testid={subtitleTestId}>{subtitleText}</span>
    ) : (
      subtitleText
    );

  return (
    <DirectoryEntityRow
      thumb={thumb}
      title={
        titleTestId !== undefined ? (
          <span className="line-clamp-2" data-testid={titleTestId}>
            {offer.title}
          </span>
        ) : (
          <span className="line-clamp-2">{offer.title}</span>
        )
      }
      subtitle={subtitleText.length > 0 ? subtitle : undefined}
      density={density}
      layout={layout}
      testId={testId}
      trailing={trailing}
    />
  );
}
